import React from "react";
import { useMyRoyaltyReminders } from "@seabrookstudios/pitch2table";
import { idExtractor, useMakeListAndDetail, useMakeListBuilder } from "../core/useMakeLayout";
import { Path } from "../Path";
import { NoItemsFound } from "../publisher/NoItemsFound";
import { AddRoyaltyReminderDialog } from "./AddRoyaltyReminderDialog";
import { RoyaltyReminderDetail } from "./RoyaltyReminderDetail";
import { RoyaltyReminderListEntry } from "./RoyaltyReminderListEntry";

export const NoRoyaltyReminders = () => (
  <NoItemsFound>
    <p>No royalty reminders set.</p>
  </NoItemsFound>
);

export const RoyaltyRemindersListAndDetail = () => {
  const Action = () => <AddRoyaltyReminderDialog />;
  const useMakeList = useMakeListBuilder(
    RoyaltyReminderListEntry,
    idExtractor,
    "Royalty Reminders",
    NoRoyaltyReminders,
    Action,
    undefined,
    Path.royalties().none(),
  );

  const ListAndDetail = useMakeListAndDetail(
    useMyRoyaltyReminders,
    [],
    "royalty-reminders",
    useMakeList,
    RoyaltyReminderDetail,
  );

  return <ListAndDetail />;
};
